import React from 'react';
import Popover, { PopoverProps } from '@material-ui/core/Popover';
import { useDisableFocusTrapWithChatProps } from '@components/ChatAwareComponents/utilities/hooks/useDisableFocusTrapWithChatProps/useDisableFocusTrapWithChatProps';

export const ChatAwarePopover: React.FC<PopoverProps> = ({ children, ...popoverProps }) => {
	const disableFocusTrapWithChatProps = useDisableFocusTrapWithChatProps();

	return (
		<Popover
			{...disableFocusTrapWithChatProps}
			{...popoverProps}
		>
			{children}
		</Popover>
	);
};
